import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { productMeasurements, calculationSpecs } from '@state';
import { formatMoney } from '@shopify/theme-currency';
// import ProductBreadcrumbs from './ProductBreadcrumbs';
import PremiumInfo from './PremiumInfo';

const ProductMainHeader = ({ product }) => {
  const measurements = useRecoilValue(productMeasurements);
  const specs = useRecoilValue(calculationSpecs);

  return (
    <header className="ProductMain__header">
      <>
        {/* <ProductBreadcrumbs product={product}></ProductBreadcrumbs> */}
        <h1>{product.title}</h1>
        {/* <div className="yotpo bottomLine" data-product-id={product.id}></div> */}
        {measurements?.minCost && specs && (
          <div className="Product__priceRange">
            <span className="min">
              <small>Starting at</small> {formatMoney(measurements.minCost)}
            </span>
            <PremiumInfo></PremiumInfo>
          </div>
        )}
        {/* {measurements?.minCost && measurements?.maxCost && (
          <div className="Product__priceRange">
            <span className="min">{formatMoney(measurements.minCost)}</span> -{' '}
            <span className="min">{formatMoney(measurements.maxCost)}</span>
          </div>
        )} */}
      </>
    </header>
  );
};

export default ProductMainHeader;
